import Clarity from '@microsoft/clarity';

import { getUserId, isUserLoggedIn } from '@/helpers/auth/auth';
import { getCache, hasCache, setCache } from '@/helpers/persistent-cache';

const PROJECT_ID = 't4zvzijvs0'; // Replace with actual project ID
const ENABLED_CACHE_KEY = 'clarity_enabled';
const RECORDINGS_PERCENT = 50;

// https://docs.microsoft.com/en-us/clarity/
function loadScript(): void {
  Clarity.init(PROJECT_ID);
}

export function identifyUser(userId: string): void {
  Clarity.identify(userId, undefined, undefined, userId);
}

export function setIsEnabled(value: boolean): void {
  setCache(ENABLED_CACHE_KEY, value ? '1' : '0');
}

export function sendClarityEvent(eventName: string) {
  if (getIsEnabled() && isInitialized) {
    Clarity.event(eventName);
  }
}

export function setClarityTag(key: string, value: string) {
  if (getIsEnabled() && isInitialized) {
    Clarity.setTag(key, value);
  }
}

export function getIsEnabled(): boolean {
  return getCache(ENABLED_CACHE_KEY) === '1';
}

export function hasIsEnabled(): boolean {
  return hasCache(ENABLED_CACHE_KEY);
}

export function getIsRandomlyAllowed(): boolean {
  // const isEnvEnabled = +import.meta.env.VUE_APP_IS_CLARITY_ENABLED !== 0;
  return Math.random() * 100 <= RECORDINGS_PERCENT;
}

let isInitialized = false;
export async function runClarity(): Promise<void> {
  if (!isUserLoggedIn() || isInitialized) {
    return;
  }

  if (!hasIsEnabled()) {
    const isEnabled = getIsRandomlyAllowed();
    setIsEnabled(isEnabled);
  }

  if (getIsEnabled()) {
    loadScript();
    identifyUser(getUserId());
  }

  isInitialized = true;
}
